import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-task-update-task-document-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe],
})
export class TaskUpdateTaskDocumentApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Add Document to Task",
            description:
                "This endpoint can be used to add a document to an existing task. This is only available for tasks that are currently not in status 'Done'",
            httpMethod: "POST",
            path: "/taskdata/v1/tasks/{guid}/add/document",

            parameters: [
                {
                    name: "guid",
                    description: "guid of the task to add the document to",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "document",
                    description: "single file that should be added to the task",
                    in: "file",
                    paramType: "formData",
                    required: true,
                    example: "binary",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                },
            ],
        };
    }
}
